import React, { Component } from 'react';

import moment from 'moment';
import { array } from 'prop-types';

import { Expression } from '@philips-emr/tws-constants';
import { date, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';

import { EventTokenList } from '../..';

class DatePickerEventsPanel extends Component {

  static propTypes = {
    date: date,
    data: array,
    todayExpression: expression,
    noAppointmentsExpression: expression,
  };

  static defaultProps = {
    data: [],
    todayExpression: Expression.TODAY,
    noAppointmentsExp: Expression.NO_APPOINTMENTS,
  };

  isSameDate = (dateA, dateB) => {
    return moment(dateA).utc().isSame(moment(dateB).utc(), 'date');
  };

  getEvents() {
    const { data, date } = this.props;

    if (!Array.isArray(data)) return [];

    return data.filter(item => (
      this.isSameDate(date, item.date)
    ));
  }

  formatDateDisplay = (date, todayExp) => {
    if (moment.utc().isSame(date, 'date')) {
      return <span>{date.format('LL')} - { todayExp }</span>;
    }

    return <span>{date.format('LL')} - {date.format('dddd')}</span>;
  };

  render() {
    const { date, todayExpression, noAppointmentsExpression } = this.props;
    const events = this.getEvents();

    return (
      <div className="c-date-picker__events">
        <span className="c-date-picker__events-date">
          {this.formatDateDisplay(date, todayExpression)}
        </span>

        {events.length
          ? <EventTokenList data={events} />
          : <span className="c-date-picker__no-events">{msg(noAppointmentsExpression)}</span>}
      </div>
    );

  }

}

export default DatePickerEventsPanel;
